<div class="d-flex justify-content-end border-top flex-wrap">
  <span class="btn btn-sm">Actions:</span>
  <era-device-scheduled-tasks-cancel-ui (cancelled)="cancel()"> </era-device-scheduled-tasks-cancel-ui>
</div>